import { useEffect } from "react";

// Lightweight per-page SEO: updates <title>, meta description/keywords,
// canonical + Open Graph. Focused on Ohio + DODD home care.
export default function useSeo({ title, description, path = "/", keywords, robots }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "robots", robots || "index,follow");
    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `https://myohcare.com${path}`);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `https://myohcare.com${path}`);
  }, [title, description, path, keywords, robots]);
}
